import './Footer.css'
import { Link } from 'react-router'

function Footer() {
    return (
        <footer>
            <div className="container">
                <div className="row py-5">
                    {/* <div className="col-md-3 col-sm-6 col-xs-12 d-flex flex-column">
                        <h5>SECCIONES</h5>
                        <Link to="/">INICIO</Link>
                        <Link to="/proyectos">PROYECTOS</Link>
                        <Link to="/contacto">CONTACTO</Link>
                    </div> */}

                    <div className="col-md-4     col-sm-6 col-xs-12 d-flex flex-column">
                        <h5>DIRECCIÓN</h5>
                        <p>
                            RÍO MUGNONE #321, PRIVANZAS DEL CAMPESTRE<br />
                            ARTEAGA, COAH. MÉXICO<br />
                            CP 25369
                        </p>
                    </div>

                    <div className="col-md-4 col-sm-6 col-xs-12 d-flex flex-column">
                        <h5>CONTACTO</h5>
                        <p>
                            {/* TEL: <a href="tel:+528444163232">+52 844 416 3232</a> <br/>
                            CEL: <a href="tel:+528444270264">+52 844 427 0264</a> <br/> */}
                            <a href='mailto:contacto@nuvlar.com'>contacto@nuvlar.com</a>
                        </p>
                    </div>

                    <div className="col-md-4 col-sm-6 col-xs-12 d-flex flex-column">
                        <h5>DERECHOS RESERVADOS</h5>
                        <p>
                            Nuvlar SA de CV 2012-{new Date().getFullYear()} <br />
                            <Link to="/legal">Política de Privacidad</Link>
                        </p>
                        <div className='d-flex align-items-center'>
                            <a target='_blank' rel="noreferrer" href="https://www.facebook.com/Nuvlar"><i className="fa-brands fa-facebook-f px-1"></i></a>
                            <a target='_blank' rel="noreferrer" href="https://x.com/Nuvlar"><i className="fa-brands fa-x-twitter px-1"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer